<template>
  <div>
    <div :class="{'large-select': large}">
      <v-select v-model="selected" label="label" :options="options" :reduce="o => o.value" placeholder="Select a preference...">
      </v-select>
    </div>
  </div>
</template>

<script>

export default {
    props:{
        value: {
            type: String,
        },
        large: {
          type: Boolean,
          default: false,
        }
    },
    data(){
        return {
            options: [{
                label: 'Phone',
                value: 'phone'
             }, {
                 label: 'Email',
                 value: 'email'
             }]
        }
    },
    computed: {
    selected: {
      set(newVal){
        this.$emit("input", newVal);
      },
      get(){
        return this.value;
      },
    },
  },
};
</script>
